<script lang="ts" setup>
  import { useBannerStore } from '@/stores/banner';
  import { useUserStore } from '@/stores/user';
  import type { VDefaultLayoutProps } from './types';

  defineProps<VDefaultLayoutProps>();

  const { t, locale } = useI18n({
    messages: {
      ru: {
        demoAccount:
          'Вы используете демонстрационный аккаунт, некоторые функции недоступны',
        noRecoveryWarn:
          'Мы добавили коды восстановления — переподключите двухфакторную аутентификацию, чтобы получить их и восстановить доступ при необходимости.',
      },
      en: {
        demoAccount:
          'You are using a demo account, some features are not available',
        noRecoveryWarn:
          'We have added recovery codes — re-enable two-factor authentication to obtain them and restore access if necessary.',
      },
    },
  });

  const bannerStore = useBannerStore();
  const userStore = useUserStore();

  const setBannerForDemoUser = () => {
    if (userStore.user?.isDemo) {
      bannerStore.setBanner(t('demoAccount'), false);
    }
  };

  const setBannerRecoveryCodeWarn = () => {
    if (
      userStore.user &&
      userStore.user.totpEnabled &&
      !userStore.user.hasRecoveryCodes
    ) {
      bannerStore.setBanner(t('noRecoveryWarn'), false);
    }
  };

  onMounted(() => {
    setBannerForDemoUser();
    setBannerRecoveryCodeWarn();
  });

  watch(
    () => locale.value,
    () => {
      setBannerForDemoUser();
    },
  );
</script>

<template>
  <VBaseLayout :title="title" data-testid="base">
    <div class="min-h-[calc(100dvh-90px)]">
      <div class="container-fluid mb-32 grid gap-16">
        <VHeader
          data-testid="header"
          :breadcrumbs="breadcrumbs"
          :title="title" />
        <VCloudStatusBanner />
        <VBanner v-if="bannerStore.message" data-testid="banner" />
        <slot />
      </div>
    </div>
    <VFooter />
  </VBaseLayout>
</template>
